export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
};

export const SUBSCRIPTION_INTERVAL = {
  MONTHLY: "MONTHLY",
  BIANNUAL: "BIANNUAL",
  ANNUAL: "ANNUAL"
}

export const SUBSCRIPTION_STATUS = {
  CANCELLED: "CANCELLED",
  ACTIVE: "ACTIVE",
  INITIALIZING: "INITIALIZING",
  INITIALIZING_FAILED: "INITIALIZING_FAILED",
  PAST_DUE: "PAST_DUE",
  WILL_CANCEL: "WILL_CANCEL",
  NEVER: "NEVER"
}

export const PLAID_ACCOUNT_STATE = {
  PENDING: "PENDING",
  LINKED: "LINKED",
  LINK_FAILED: "LINK_FAILED",
  EXPIRED: "EXPIRED",
  DELETED: "DELETED",
  REJECTED: "REJECTED"
}

export const PAYMENT_PRODUCT_TYPE = {
  CREDIT_CARD: 'CREDIT_CARD',
  LOAN: 'LOAN',
  SAVINGS_BUILDER: 'SAVINGS_BUILDER',
  SUBSCRIPTION: 'SUBSCRIPTION',
  GENERAL_REFUND: 'GENERAL_REFUND',
}


export const MONTHS = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
]
